webpackJsonp([2782189781743],{

/***/ 1919:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PaymentReason","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-payment-reason-ee62b5a2f980ff86cb1b.js